import { numericScore, qualitativeScoreLabel } from './scoreLabel';

const numericConfidence = (value: unknown, fractional = false): number | null => {
    const parsed = numericScore(value);
    if (parsed === null)
        return null;
    const percent = fractional && !String(value).includes('%') && parsed > 0 && parsed <= 1 ? parsed * 100 : parsed;
    return percent >= 0 && percent <= 100 ? Math.round(percent) : null;
};

export const getEventConfidencePercent = (event: any): number | null => {
    if (event?.vettingVersion === '2.0' && ['vertex_google_search', 'trusted_primary_feed'].includes(event?.vettingMethod))
        return null;

    const stored = [
        event?.confidencePercent,
        event?.confidence_percentage,
        event?.confidenceScore,
        event?.confidence_score,
        event?.confidence?.percentage,
        event?.confidence?.score,
        event?.confidence,
        event?.analystConfidence?.score,
    ];
    for (let index = 0; index < stored.length; index++) {
        const parsed = numericConfidence(stored[index], index === 5 || index === 6);
        if (parsed !== null)
            return parsed;
    }

    return null;
};

export const formatEventConfidence = (event: any): string => {
    const percent = getEventConfidencePercent(event);
    return percent === null ? qualitativeScoreLabel([
        event?.confidenceScore, event?.confidence_score, event?.confidencePercent, event?.confidence_percentage,
        event?.confidence?.score, event?.confidence?.level, event?.confidence, event?.confidenceLevel,
        event?.analystConfidence?.score,
    ]) || 'Not assessed' : `${percent}%`;
};

export const formatEventConfidenceLevel = (event: any): string => {
    const percent = getEventConfidencePercent(event);
    return percent === null ? formatEventConfidence(event) : `${percent}% · ${percent < 60 ? 'Low' : percent < 80 ? 'Medium' : 'High'}`;
};
